// @ts-nocheck
import { Plugin } from '/var/jenkins_home/workspace/vinda/vinda-prod-frontend/node_modules/@umijs/preset-built-in/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','locale','layout','layoutActionRef','request',],
});

export { plugin };
